import { Action } from '@ngrx/store';
import { IProduct } from 'src/app/models/products.model';
import { ICommerceProduct } from '../models/order.model';

export const SET_PRODUCT_COMMERCE = '[Products commerce] Set Products';
export const UNSET_PRODUCT_COMMERCE = '[Products commerce] Unset Products';


export class SetProductsCommerceActions implements Action {
    readonly type = SET_PRODUCT_COMMERCE;

    constructor(public products: ICommerceProduct[]) { }
}

export class UnsetProductsCommerceAction implements Action {
    readonly type = UNSET_PRODUCT_COMMERCE;
}


export type acciones = SetProductsCommerceActions | UnsetProductsCommerceAction;
